export const EVENTS = {
  LOGIN_STATE_CHANGED  : 'loginStateChanged',
  LOGIN_STATE_EXPIRED  : 'loginStateExpire',
  LOGIN_TYPE_CHANGED   : 'loginTypeChanged',
  ANONYMOUS_CONVERTED  : 'anonymousConverted', //匿名账户被转正后触发
  ACCESS_TOKEN_REFRESHD: 'refreshAccessToken'
};
